export default [
    {
        name: 'Qualidade',
        options: [
            {
                id: 10401,
                label: 'Qualidade',
                name: 'Dano',
            },
            {
                id: 10402,
                label: 'Qualidade',
                name: 'Trabalho incompleto',
            },
            {
                id: 10403,
                label: 'Qualidade',
                name: 'Acabamento insatisfstório',
            },
            {
                id: 10404,
                label: 'Qualidade',
                name: 'Erro de execução',
            },
        ],
    },
    {
        name: 'Projeto',
        options: [
            {
                id: 10405,
                label: 'Projeto',
                name: 'Não previsto em projeto',
            },
            {
                id: 10406,
                label: 'Projeto',
                name: 'Conflito com projeto',
            },
            {
                id: 10407,
                label: 'Projeto',
                name: 'Mudança no projeto',
            },
        ],
    },
]
